module.exports = __webpack_public_path__ + "media/images/svgs/nikolaevskie-13d16579403c301670e2d1c3c3d83c07.svg";